<template>
  <el-radio-group v-if="items?.length <= 4" v-bind="$attrs">
    <el-radio-button
      :label="item[valueKey]"
      v-for="item in items"
      :key="item[valueKey]"
	>{{item[labelKey]}}</el-radio-button>
  </el-radio-group>
  <el-select v-else v-bind="$attrs">
    <el-option
      v-for="item in items"
      :key="item[valueKey]"
      :label="item[labelKey]"
      :value="item[valueKey]"
    >
      <slot name="option" :data="item"></slot>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "ScEmum",
  props: {
    items: {
      type: Array,
      required: true,
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
  },
};
</script>

<style>
</style>
